import mesh from '../assets/images/Mesh1.png';
const Products6 = [
    { id: 1, name: 'Knitted Pressed Mesh Anti', image:mesh},
];

export default Products6;